// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { slideshowStyles } from "@tps/Overrides/Widgets/Basic/Slideshow";
import { color, ellipsis, xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

slideshowStyles.slideshowWrapper = {
    css: css`
        position: relative;
    `,
};
slideshowStyles.prevArrowWrapper = {
    css: css`
        position: absolute;
        z-index: 1;
        top: 50%;
        transform: translate(0, -50%);
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};
slideshowStyles.prevArrowButton = {
    css: css`
        background: none;
        border: 0;
        padding: 0;
        &:hover {
            background: none;
        }
        &:focus {
            outline: none;
        }
    `,
};
slideshowStyles.iconProps = {
    css: css`
        opacity: 0.66;
        &${IconWrapper}, svg {
            width: 42px;
            height: 85px;
        }
        &&& {
            color: ${color("primary.main")};
            &:hover {
                opacity: 1;
                color: ${color("common.ui8")};
            }
        }
    `,
};
slideshowStyles.carouselContainer = {
    css: css`
        overflow: hidden;
    `,
};
slideshowStyles.slideContentWrapper = {
    css: css`
        display: flex;
        flex: 0 0 100%;
        position: relative;
        color: white;
        background-repeat: no-repeat;
    `,
};
slideshowStyles.slideOverlayWrapper = {
    css: css`
        width: 100%;
    `,
};
slideshowStyles.slideContainerWrapper = {
    css: css`
        display: flex;
    `,
};
slideshowStyles.slideContentStyles = {
    css: css`
        max-width: 543px;
        &:empty {
            display: none;
        }
        ${xScreen("lte", "md")} {
            max-width: 100%;
        }
    `,
};
slideshowStyles.slideButton = {
    css: css`
        width: fit-content;
        ${({ alignment }: any) => {
            if (alignment === "center") {
                return css`
                    margin: auto;
                `;
            }
            if (alignment === "right") {
                return css`
                    margin-left: auto;
                `;
            }
        }}
    `,
};

slideshowStyles.dotsContainerWrapper = {
    css: css`
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 16px;
        width: 100%;
        ${xScreen("lte", "md")} {
            margin-top: 52px;
        }
    `,
};
slideshowStyles.dotButton = {
    css: css`
        height: 10px;
        width: 10px;
        min-height: unset;
        padding: 0;
        margin-right: 8px;
        border-radius: 5px;
        border: 1px solid ${color("common.ui4")};
        background: ${color("common.ui1")};
        &:hover,
        &:active {
            background: ${color("common.ui8")};
            border: 0;
        }
        &:active {
            background: ${color("common.ui9")};
            border: 0;
        }
        &:focus {
            outline: none;
        }
    `,
};
slideshowStyles.nextArrowWrapper = {
    css: css`
        position: absolute;
        z-index: 1;
        top: 50%;
        right: 0;
        transform: translate(0, -50%);
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};
slideshowStyles.nextArrowButton = {
    css: css`
        background: none;
        border: 0;
        padding: 0;
        &:hover {
            background: none;
        }
        &:focus {
            outline: none;
        }
    `,
};
// xng
slideshowStyles.headingText = {
    css: css`
        p {
            font-size: 38px;
            font-weight: 700;
            letter-spacing: 0;
            line-height: 46px;
            margin-bottom: 20px;
            color: ${color("common.ui1")};
            ${xScreen("lte", "md")} {
                color: ${color("text.main")};
            }
        }
    `,
};
slideshowStyles.subheadingText = {
    css: css`
        p {
            margin-bottom: 20px;
            font-size: 20px;
            font-weight: 700;
            letter-spacing: 0;
            line-height: 28px;
            color: ${color("common.ui1")};
            ${ellipsis(3)};
            ${xScreen("lte", "md")} {
                color: ${color("text.main")};
                ${ellipsis(3)};
            }
            ${xScreen("lte", "xs")} {
                ${ellipsis(4)};
            }
        }
    `,
};
slideshowStyles.image = {
    css: css`
        &,
        img {
            width: 100%;
            height: auto;
            max-height: 100%;
        }
    `,
};
